import type { SVGProps } from "react";

export function LocationIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M5.05073 4.0508C7.7844 1.31656 12.2166 1.31624 14.9501 4.0508C17.6836 6.78556 17.6834 11.2202 14.9501 13.9551L13.8222 15.0693L11.3866 17.4394C10.6568 18.1458 9.52176 18.1845 8.747 17.5566L8.61419 17.4394L6.57123 15.4541L5.05073 13.9551C2.31707 11.2202 2.31707 6.78565 5.05073 4.0508ZM9.99992 6.50001C8.61935 6.50012 7.5 7.61941 7.49994 9C7.49994 10.3806 8.61932 11.4999 9.99992 11.5C11.3805 11.4998 12.4999 10.3806 12.4999 9C12.4999 7.61944 11.3805 6.50017 9.99992 6.50001Z"
        fill={props.fill || "#EF4444"}
      />
    </svg>
  );
}
